<div [formGroup]="form" class="search" style="margin-top: 3px;" [style.width]="width">
  <jad-form-fields-text (keyup.enter)="emitValue()" [control]="form.controls.search" [suffix]="'search'" [hasIconSuffix]="true"  [suffixPosition]="'end'" [placeholder]="placeholder | translate"></jad-form-fields-text>
</div>